import { PageMeta } from '../components/PageMeta';
import { Band, Btn, Container } from '../site/primitives';
import { AstronautArt, CustomerEssentials, Hero } from '../site/sections';
import { ART } from '../site/media';

export function ClaimsCenterPage() {
  return <>
    <PageMeta title="Claims Center" description="File a new Enshield Package Protection claim or securely track an existing claim." />
    <Hero compact titleId="claims-center-title" eyebrow="Customer support" title={<>Claims Center</>} lead="When a protected delivery is lost, stolen, or damaged, come directly to Enshield. Choose what you need below." art={<AstronautArt {...ART.evidence} support priority className="astra-support-guide" />} />
    <Band space="standard" labelledBy="claims-actions-title">
      <Container width="read">
        <h2 id="claims-actions-title" className="sr-only">Claim actions</h2>
        <div className="astra-claims-options">
          <article className="astra-claims-option"><span>01 / START HERE</span><h3 className="u-h3">File a Claim</h3><p className="u-body">Start a claim for a protected order using your order details.</p><Btn to="/file-a-claim">File a Claim</Btn></article>
          <article className="astra-claims-option"><span>02 / ALREADY FILED?</span><h3 className="u-h3">Track a Claim</h3><p className="u-body">Use your secure tracking link or token to see the latest update.</p><Btn tone="secondary" to="/track-claim">Track a Claim</Btn></article>
        </div>
      </Container>
    </Band>
    <CustomerEssentials />
  </>;
}
